export default __webpack_public_path__ + "static/shopping-1-ab58a1d773feb27c38269ddb83bacd06.jpg";